import { render, staticRenderFns } from "./PatientDispensesMonitor.html?vue&type=template&id=aee21b5e&external"
import script from "./PatientDispensesMonitor.js?vue&type=script&lang=js&external"
export * from "./PatientDispensesMonitor.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports